export enum OpportunityStatusesEnum {
  INCOMING = 1,
  SOURCE_PENDING = 2,
}
